import Cookies from "js-cookie"

const isLocalhost = hostname => {
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname === ""
}

const getAgency = () => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname
    if (isLocalhost(hostname)) {
      const tenant = Cookies.get("tenant")
      if (tenant === "KSA") return "bayut"
      if (tenant === "PK") return "pk"
      return "zameen"
    }
    if (process.env.REACT_APP_NODE_ENV === "production") {
      const agency = window.location.host.split(".")[0]
      return agency
    }
  }
  const tenant = Cookies.get("tenant")
  if (tenant === "KSA") return "bayut"
  if (tenant === "PK") return "pk"
  return "zameen"
}

const getTenant = () => {
  // First check for REACT_APP_TENANT environment variable
  if (process.env.REACT_APP_TENANT) {
    return process.env.REACT_APP_TENANT
  }

  if (typeof window !== "undefined") {
    const hostname = window.location.hostname
    if (isLocalhost(hostname)) {
      return Cookies.get("tenant") === "KSA" ? "ksa" : "pk"
    }
    if (process.env.REACT_APP_NODE_ENV === "production") {
      const tenant = window.location.host.split(".")[0]
      return tenant
    }
  }
  return Cookies.get("tenant") === "KSA" ? "ksa" : "pk"
}

export const CURRENT_TENANT = getTenant()
export const IS_CURRENT_TENANT_KSA = CURRENT_TENANT === "ksa"
export const IS_CURRENT_TENANT_PK = CURRENT_TENANT === "pk"
export const AGENCY = getAgency()
